import DropDown from '@/src/components/Antd/DropDown/DropDown';
import Menu from '@/src/components/Antd/Menu/Menu';
import MenuItem from '@/src/components/Antd/Menu/MenuItem/MenuItem/Menu';
import Tag from '@/src/components/Antd/Tag/Tag';
import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import { DownOutlined } from '@ant-design/icons';
import React from 'react';
import { EnumStatus } from 'src/types/common/common';
import { modal } from 'src/utils/Modal';
import css from './css.less';
const list = (getI18n) => [
  {
    value: EnumStatus.Active,
    body: (
      <Tag color='success' className={css.tagClass} status={EnumStatus.Active}>
        {getI18n(
          'giftCard.giftCardDetail.giftcardinfo_statustag_list_activetag',
        )}
      </Tag>
    ),
  },
  {
    value: EnumStatus.ZeroBalance,
    body: (
      <Tag
        color='default'
        className={css.tagClass}
        status={EnumStatus.ZeroBalance}>
        {getI18n('giftCard.giftCardDetail.giftcardinfo_statustag_list_zerotag')}
      </Tag>
    ),
  },
  {
    value: EnumStatus.Expired,
    body: (
      <Tag color='default' className={css.tagClass} status={EnumStatus.Active}>
        {getI18n(
          'giftCard.giftCardDetail.giftcardinfo_statustag_list_expiretag',
        )}
      </Tag>
    ),
  },
  {
    value: EnumStatus.Locked,
    body: (
      <Tag color='default' className={css.tagClass} status={EnumStatus.Locked}>
        {getI18n('giftCard.giftCardDetail.giftcardinfo_statustag_list_locktag')}
      </Tag>
    ),
  },
];
const Status = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { status, title, disabled, onChangeStatus } = props;

  const tagList = React.useMemo(() => {
    const list = [
      {
        value: EnumStatus.Active,
        body: (
          <Tag
            color='success'
            className={css.tagClass}
            status={EnumStatus.Active}>
            {getI18n(
              'giftCard.giftCardDetail.giftcardinfo_statustag_list_activetag',
            )}
          </Tag>
        ),
      },
      {
        value: EnumStatus.Used,
        body: (
          <Tag
            color='default'
            className={css.tagClass}
            status={EnumStatus.Locked}>
            {getI18n(
              'giftCard.giftCardDetail.giftcardinfo_statustag_list_locktag',
            )}
          </Tag>
        ),
      },
    ];

    return list;
  }, [status]);

  const toActive = () => {
    modal.error({
      title: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_title',
      ),
      content: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_content',
      ),
      onOkText: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_onOktext',
      ),
      onCancel: () => {
        return;
      },
      onCancelText: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_oncanceltext',
      ),
      onOk: () => {
        if (status !== EnumStatus.Active) onChangeStatus(EnumStatus.Active);
      },
    });
  };
  const toInactive = () => {
    modal.error({
      title: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_title',
      ),
      content: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toInactive_error_content',
      ),
      onOkText: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_onOktext',
      ),
      onCancel: () => {
        return;
      },
      onCancelText: getI18n(
        'giftCard.giftCardDetail.giftcardinfo_statustag_toactive_error_oncanceltext',
      ),
      onOk: () => {
        if (status !== EnumStatus.Locked) onChangeStatus(EnumStatus.Locked);
      },
    });
  };
  const statusOnChange = {
    [EnumStatus.Used]: toInactive,
    [EnumStatus.Active]: toActive,
  };
  const overlay = (
    <Menu
      disabled={disabled}
      selectedKeys={status}
      className={css.overlayClass}
      onSelect={(e) => {
        if (statusOnChange[e.key]) {
          statusOnChange[e.key]();
        } //statusOnChange[e.key]();
      }}>
      {tagList.map((list, index) =>
        status !== EnumStatus.Expired &&
        status !== EnumStatus.ZeroBalance &&
        status !== list.value ? (
          <MenuItem className={css.overlaylist} key={list.value}>
            {list.body}
          </MenuItem>
        ) : null,
      )}
    </Menu>
  );
  const displayTag = React.useMemo(() => {
    const tag = list(getI18n).find((i) => i.value === status);
    if (tag) {
      return tag.body;
    }
    return tagList[0].body;
  }, [status]);
  return (
    <div className={css.itemContainer}>
      <DropDown overlay={overlay} trigger={['click']} disabled={disabled}>
        <div className={css.dropItem}>
          {displayTag}
          {status !== EnumStatus.Expired &&
          status !== EnumStatus.ZeroBalance ? (
            <DownOutlined className={css.overlayIcon} />
          ) : null}
        </div>
      </DropDown>
      <p className={css.titleText}>{title}</p>
    </div>
  );
};
export default Status;
